// Global tap feedback: a short click sound + light haptic buzz whenever an
// interactive element (button, link, action tile, nav item) is pressed.
// Visual press feedback is handled in CSS (mobile.css :active rules).

import { Haptics, ImpactStyle } from '@capacitor/haptics'

const INTERACTIVE = [
  'button',
  'a',
  '.btn',
  '.box.btn-icon-box',
  '.btn-icon-box',
  '.action-btn',
  '.seg-btn',
  '.status-pill',
  '.shell-mobile-bottom-link',
  '.shell-drawer-link',
  '[role="button"]',
].join(',')

let audioCtx = null

// A short, soft click generated with the Web Audio API (no asset needed).
function playClick() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext
    if (!Ctx) return
    audioCtx = audioCtx || new Ctx()
    if (audioCtx.state === 'suspended') audioCtx.resume()
    const osc = audioCtx.createOscillator()
    const gain = audioCtx.createGain()
    osc.type = 'square'
    osc.frequency.value = 170
    const t = audioCtx.currentTime
    gain.gain.setValueAtTime(0.05, t)
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.035)
    osc.connect(gain)
    gain.connect(audioCtx.destination)
    osc.start(t)
    osc.stop(t + 0.045)
  } catch (_) {
    /* audio not available — ignore */
  }
}

function buzz() {
  try {
    Haptics.impact({ style: ImpactStyle.Light })
  } catch (_) {
    /* not on a native device — ignore */
  }
}

export function registerTapFeedback() {
  // Capture phase so it still fires even if a handler stops propagation.
  document.addEventListener(
    'pointerdown',
    (e) => {
      const el = e.target && e.target.closest && e.target.closest(INTERACTIVE)
      if (!el || el.classList.contains('disabled') || el.disabled) return
      playClick()
      buzz()
    },
    true
  )
}